import { Show } from "solid-js";
import { cn } from "~/lib/utils";

// In-app loader for route/data pending states. Three brand-red gantry lights
// stagger-breathing, fixed at the same viewport coord as the boot loader's
// gantry (top: 120px), so the cold-start <kuro-loader> handing off to this
// reads as the racing scene fading and its gantry persisting. The full
// racing scene is reserved for boot (see <kuro-loader> in index.html), where
// it has the multi-second runway it needs — short in-app pending bursts get
// only this quieter indicator.
//
// Pass label="" to hide the visible text (keeps sr-only "Loading" for AT).
export function Loader(props: { label?: string; class?: string }) {
  return (
    <div class={cn(props.class)} role="status" aria-live="polite">
      <div class="kuro-loader-gantry" aria-hidden="true">
        <span class="kuro-loader-light" />
        <span class="kuro-loader-light" />
        <span class="kuro-loader-light" />
      </div>
      <Show when={props.label !== ""} fallback={<span class="sr-only">Loading</span>}>
        <span class="kuro-loader-label">{props.label ?? "Loading"}</span>
      </Show>
    </div>
  );
}
